<template>
    <div ref="playerContainer" class="player-container" />
</template>

<script>
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
import {TitleBar} from '@modules/videojs-title-component';

export default {
    name: 'VideoPlayer',
    props: {
        height: { type: Number, required: true },
        streamingUrl: { type: String, required: true },
        channelName: { type: String, required: true },
        options: { type: Object, default: () => { } },
        autoplay: { type: Boolean, default: true },
        controls: { type: Boolean, default: true },
        mediaType: { type: String, default: 'application/x-mpegURL' },
        muted: { type: Boolean, default: true },
    },
    data() {
        return {
            player: null
        }
    },
    watch: {
        streamingUrl() {
            this.getNewPlayer(this.streamingUrl, this.channelName);
        }
    },
    mounted() {
        this.getNewPlayer(this.streamingUrl, this.channelName);
    },
    beforeDestroy() {
        if (this.player) {
            this.player.dispose();
        }
    },
    methods: {
        getNewPlayer(streamingUrl, channelName) {
            if (this.player !== null) {
                this.player.dispose();
            }

            this.$refs.playerContainer.innerHTML = '<video id="videoPlayer" class="video-js" />';

            const options = {
                autoplay: this.autoplay,
                controls: this.controls,
                muted: this.muted,
                sources: [
                    { src: streamingUrl, type: this.mediaType }
                ],
                src: streamingUrl,
                height: this.height,
                // aspectRatio: this.resolution.ratio,
                // fluid: true,
            };

            videojs.registerComponent('TitleBar', TitleBar);
            this.player = videojs('videoPlayer', options, () => {
                this.player.on('volumechange', (evt) => {
                    this.$emit('mute-toggle', evt.target.children[0].muted);
                });
            });

            this.player.addChild('TitleBar', {text: channelName});
        }
    },
}
</script>
